module.exports = __webpack_public_path__ + "font/53ce8c8840322a10f92c5828d3221e22.ttf";